module.exports = __webpack_public_path__ + "static/bloomed-e2a9831c6dd3d50f7413c76bb95e14e7.jpg";